import { createI18n } from 'vue-i18n';
import EN from '@/lang/en.json';
import FR from '@/lang/fr.json';
import vuetifyFR from '@/lang/vuetifyFR';
import vuetifyEN from '@/lang/vuetifyEN';
import clientConfig from '@/client_customs/config';

const helpers = {
  elDefaultTitle({ named, linked }) {
    if (named('type') == 'macro') return linked('PLANNING.NEW_MACRO_BUBBLE');
    return named('type') == 'milestone' ? linked('PLANNING.MILESTONE') : linked('PLANNING.NEW_BUBBLE');
  },
  valueOrCount({ named }) {
    return named('value') ?? named('count');
  },
  workloadCount({ named, linked }) {
    return named('workloadInHours') ? linked('GLOBAL.HOURS_COUNT') : linked('GLOBAL.DAYS_COUNT');
  },
  workloadShort({ named, linked }) {
    return named('workloadInHours') ? linked('PROJECT_SHEET.HOURS_SHORT') : linked('PROJECT_SHEET.DAYS_SHORT');
  },
};

const initLang = window.localStorageWrapper.getItem('lang') || 'en';
const i18n = createI18n({
  legacy: false,
  locale: initLang,
  fallbackLocale: 'en',
  messages: {
    en: { ...vuetifyEN, ...angular.merge(EN, clientConfig.lang?.en), helpers },
    fr: { ...vuetifyFR, ...angular.merge(FR, clientConfig.lang?.fr), helpers },
  },
});

export default i18n;
